import { Box, Stack, Typography, Divider } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import OverviewIcon from "assets/svg/OverviewIcon";
import theme, { responsiveFontSize } from "themes/Theme";
import { formatNumber } from "utils/formatter";
import { commonStyle } from "../../common.styles";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { FETCH_WALLET_TYPE } from "reduxStore/actions/authActionType";
import {
  DashboardTotalBalanceData,
  DashboardTotalBalanceResponse,
} from "reduxStore/dataTypes";
import { AxiosResponse } from "axios";
import { fetchDashboardTotalBalance } from "services/apiService";
import { RootState } from "reduxStore/store";
import WalletPattern from "assets/images/Pattern.webp";
import ArrowUpRightIcon from "assets/svg/ArrowUpRightIcon";
import ArrowDropUpIcon from "assets/svg/ArrowDropUpIcon";
import ArrowDownLeftIcon from "assets/svg/Arrow 1";
import DashboardPattern from "assets/images/dashboardbg.webp";

const WalletOverviewCard = () => {
  const dispatch = useDispatch();
  const [overviewData, setOverviewData] =
    useState<DashboardTotalBalanceData | null>(null);
  const { wallet } = useSelector((state: RootState) => state.wallet);

  const fetchDashboardBalance = async () => {
    try {
      const response: AxiosResponse<DashboardTotalBalanceResponse> =
        await fetchDashboardTotalBalance();
      if (response && response.status === 200) {
        setOverviewData(response.data.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    dispatch({ type: FETCH_WALLET_TYPE });
    fetchDashboardBalance();
  }, []);

  return (
    <Box
      sx={{
        ...commonStyle.cardStyle,
        position: "relative",
        // borderRadius: "20px",
        boxShadow: "0 2px 16px 0 rgba(0,0,0,0.06)",
        height: 350,
        p: 3,
        backgroundColor: "#ffffff",
        overflow: "hidden",
      }}
    >
      {/* ✅ Background pattern image */}
      <Box
        component="img"
        src={DashboardPattern}
        alt="background pattern"
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "65%",
          opacity: 0.4,
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Foreground content */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Stack direction="row" alignItems="center" gap={1}>
          <OverviewIcon />
          <Typography sx={commonStyle.cardTitleText}>Overview</Typography>
        </Stack>

        <Typography sx={styles.totalBalanceText}>Total Balance</Typography>
        <Stack direction="row" alignItems="baseline" gap={1}>
          <Typography sx={styles.totalBalance}>
            {overviewData?.totalBalance
              ? formatNumber(Number(overviewData?.totalBalance))
              : 0}
          </Typography>
          <Typography sx={styles.totalBalanceCurrency}>
            {overviewData?.cryptoTicker || ""}
          </Typography>
        </Stack>

        <Divider sx={{ my: 2, borderColor: "#E6E6E6", mb: 4 }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#FFF9ED",
            borderRadius: "16px",
            px: 3,
            py: 2,
            mt: 1,
          }}
        >
          {/* Transferred */}
          <Box sx={{ flex: 1, pr: 2, borderRight: "1px solid #EFEFEF" }}>
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Typography sx={styles.bottomLabel}>
                Transferred (This Month)
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  // transform: "rotate(-45deg)",
                }}
              >
                <ArrowUpRightIcon
                  width={20}
                  height={20}
                  color={theme.palette.primary.main}
                />
              </Box>
            </Stack>
            <Typography sx={styles.bottomValue}>
              {Number(wallet?.data?.monthlyTransferred).toLocaleString()}{" "}
              {wallet?.data?.cryptoTicker || ""}
            </Typography>
          </Box>

          {/* Received */}
          <Box sx={{ flex: 1, pl: 2 }}>
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Typography sx={styles.bottomLabel}>
                Received (This Month)
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ArrowDownLeftIcon
                  width={11}
                  height={11}
                  color={theme.palette.primary.main}
                />
              </Box>
            </Stack>
            <Typography sx={styles.bottomValue}>
              {Number(wallet?.data?.monthlyReceived).toLocaleString()}{" "}
              {wallet?.data?.cryptoTicker || ""}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WalletOverviewCard;

const styles = {
  totalBalanceText: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.primary.main,
    marginTop: "1.5em",
    fontWeight: 500,
  },
  totalBalance: {
    fontSize: responsiveFontSize(45),
    color: theme.palette.text.primary,
    lineHeight: 1.5,
  },
  totalBalanceCurrency: {
    fontSize: responsiveFontSize(24),
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  bottomLabel: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  bottomValue: {
    fontSize: responsiveFontSize(12.29),
    color: theme.palette.custom?.green,

    mt: 0.5,
  },
};
